export const locales = [
  {
    code: 'fr',
    name: 'Français',
    iso: 'fr-FR',
    file: 'fr.json',
    phone: '05 53 55 16 18',
    country: 'FR',
    countries: ['FR', 'BE', 'CH'],
  },
  {
    code: 'en',
    name: 'English',
    iso: 'en-US',
    file: 'en.json',
    phone: '+33 5 53 55 16 18',
    country: 'GB',
    priceCountry: 'FR',
    countries: [],
  },
  {
    code: 'es',
    name: 'Español',
    iso: 'es-ES',
    file: 'es.json',
    phone: '+33 5 53 55 16 18',
    country: 'ES',
    countries: ['ES'],
  },
  {
    code: 'de',
    name: 'Deutsch',
    iso: 'de-DE',
    file: 'de.json',
    phone: '+33 5 53 55 16 18',
    country: 'DE',
    countries: ['DE'],
  },
  {
    code: 'it',
    name: 'Italiano',
    iso: 'it-IT',
    file: 'it.json',
    phone: '+33 5 53 55 16 18',
    country: 'IT',
    countries: ['IT'],
  },
  {
    code: 'pt',
    name: 'Português',
    iso: 'pt-PT',
    file: 'pt.json',
    phone: '+33 5 53 55 16 18',
    country: 'PT',
    countries: ['PT'],
  },
  {
    code: 'ja',
    name: '日本語',
    iso: 'ja-JP',
    file: 'ja.json',
    phone: '+33 5 53 55 16 18',
    country: 'JP',
    countries: ['JP'],
  },
  {
    code: 'nl',
    name: 'Nederlands',
    iso: 'nl-NL',
    file: 'nl.json',
    phone: '+33 5 53 55 16 18',
    country: 'NL',
    countries: ['NL'],
  },
  {
    code: 'pl',
    name: 'Polski',
    iso: 'pl-PL',
    file: 'pl.json',
    phone: '+33 5 53 55 16 18',
    country: 'PL',
    countries: ['PL'],
  },
  {
    code: 'sv',
    name: 'Svenska',
    iso: 'sv-SE',
    file: 'sv.json',
    phone: '+33 5 53 55 16 18',
    country: 'SE',
    countries: ['SE'],
  },
  {
    code: 'cs',
    name: 'Čeština',
    iso: 'cs-CZ',
    file: 'cs.json',
    phone: '+33 5 53 55 16 18',
    country: 'CZ',
    countries: ['CZ'],
  },
  {
    code: 'ro',
    name: 'Română',
    iso: 'ro-RO',
    file: 'ro.json',
    phone: '+33 5 53 55 16 18',
    country: 'RO',
    countries: ['RO'],
  },
  {
    code: 'da',
    name: 'Dansk',
    iso: 'da-DK',
    file: 'da.json',
    phone: '+33 5 53 55 16 18',
    country: 'DK',
    countries: ['DK'],
  },
  {
    code: 'el',
    name: 'Ελληνικά',
    iso: 'el-GR',
    file: 'el.json',
    phone: '+33 5 53 55 16 18',
    country: 'GR',
    countries: ['GR'],
  },
  {
    code: 'fi',
    name: 'Suomi',
    iso: 'fi-FI',
    file: 'fi.json',
    phone: '+33 5 53 55 16 18',
    country: 'FI',
    countries: ['FI'],
  },
  {
    code: 'no',
    name: 'Norsk',
    iso: 'nb-NO',
    file: 'no.json',
    phone: '+33 5 53 55 16 18',
    country: 'NO',
    countries: ['NO'],
  },
]

export const fallbackLocaleCode = 'en'

export function htmlLang(locale) {
  if (!locale) return undefined
  const region = String(locale.iso || '')
    .split('-')
    .slice(1)
  return [locale.code, ...region].join('-')
}

export function languageForCountry(countryIso) {
  const iso = String(countryIso || '').toUpperCase()
  const match = locales.find(locale => locale.countries.includes(iso))
  return match ? match.code : fallbackLocaleCode
}
